exponentLength